var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 16.5,
    r: 1.75,
    strokeWidth: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16.5,
    r: 1.75,
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15H20M17 15H15M5 15H6.5M3 15H2.11803C2.04041 15 1.96385 14.9819 1.89443 14.9472L1.27639 14.6382C1.107 14.5535 1 14.3804 1 14.191V13.5M1 13.5H2.5C2.77614 13.5 2.98528 13.2548 3.14612 13.0303C3.44225 12.6171 4.11746 12.5 4.5 12.5M1 13.5L1.45204 11.2398C1.4823 11.0885 1.58072 10.9596 1.71872 10.8906L2.45091 10.5245C2.48354 10.5082 2.51786 10.4955 2.55325 10.4867L4.2769 10.0558C4.4185 10.0204 4.53757 9.92486 4.60284 9.79431L5.94062 7.11876C5.97953 7.04094 6.03808 6.97461 6.11048 6.92635L6.62404 6.58397C6.70617 6.52922 6.80268 6.5 6.90139 6.5H10.0694C10.3169 6.5 10.5272 6.68107 10.5639 6.92583L10.875 9M6.5 15H10.5M6.5 15L6.75 16.5M12.5 13H11.5C11.2239 13 11 12.7761 11 12.5V10L10.875 9M12.5 13V12C12.5 11.7239 12.7239 11.5 13 11.5H13.5M12.5 13H20M20 13H20.5C20.7761 13 21 13.2239 21 13.5V14.5C21 14.7761 20.7761 15 20.5 15H20M20 13V12C20 11.7239 19.7761 11.5 19.5 11.5H19M13.5 11.5H19M13.5 11.5L12.5625 9M12 7.5V6M12 7.5L12.5625 9M12 7.5H16.5H20.5M20.5 7.5V6M20.5 7.5L19.375 10.5M19 11.5L19.375 10.5M12 6H20.5M12 6L11.2764 5.6382C11.107 5.5535 11 5.38037 11 5.19098V5M20.5 6L21.2236 5.6382C21.393 5.5535 21.5 5.38037 21.5 5.19098V5M10.5 15L10.0696 17.5822C10.0295 17.8233 9.82086 18 9.57644 18H7.42356C7.17914 18 6.97055 17.8233 6.93037 17.5822L6.75 16.5M10.5 15H11.5M11.5 15H13.5H15M11.5 15V16C11.5 16.2761 11.7239 16.5 12 16.5H14.5C14.7761 16.5 15 16.2761 15 16V15M19.375 10.5H21.191C21.3804 10.5 21.5535 10.607 21.6382 10.7764L21.9472 11.3944C21.9819 11.4639 22 11.5404 22 11.618V14C22 14.2761 22.2239 14.5 22.5 14.5V14.5C22.7761 14.5 23 14.7239 23 15V15.5C23 15.7761 22.7761 16 22.5 16H22M20 15L20.8536 15.8536C20.9473 15.9473 21.0745 16 21.2071 16H22M12.5625 9H10.875M6.75 16.5H10M22 16V17M22 17H20.5M22 17H23.5",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12H8M7.14907 8.42546L7.89443 8.05279C7.96385 8.01807 8.04041 8 8.11803 8H9C9.27614 8 9.5 8.22386 9.5 8.5V10C9.5 10.2761 9.27614 10.5 9 10.5H6.80902C6.43733 10.5 6.19558 10.1088 6.3618 9.77639L6.92546 8.64907C6.97385 8.55231 7.05231 8.47385 7.14907 8.42546Z",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLime);
export default __webpack_public_path__ + "static/media/LIME.80e273333ec936502b65a75b909c3ef5.svg";
export { ForwardRef as ReactComponent };